export const slug = (str) =>
  str.replace(/\s/gi, '-').replace(/\//g, '').toLowerCase()

export const shuffle = (arr) =>
  arr
    .map((a) => [Math.random(), a])
    .sort((a, b) => a[0] - b[0])
    .map((a) => a[1])
